if (!customElements.get('products-toolbar')) {
  class ProductsToolbar extends HTMLElement {
    constructor() {
      super();
      this.init();
    }

    init() {
      this.filtersComponent = document.querySelector('facet-filters');
      this.filtersColumn = document.querySelector('.main-products-grid__filters');
      this.layoutSwitcher = this.querySelector('.products-toolbar__layout');
      this.compareToggle = document.getElementById('compare-switch');
      this.sortBy = this.querySelector('.products-toolbar__sort');
      this.productsGrid = document.querySelector('.main-products-grid');

      if (this.filtersColumn) {
        this.filterToggle = this.querySelector('.js-toggle-filters');
        this.filterToggle.addEventListener('click', this.toggleFilters.bind(this));
      }

      if (this.layoutSwitcher) {
        this.layoutSwitcher.addEventListener('change', this.handleLayoutChange.bind(this));

        // Set the layout to the layout in localstorage
        const layout = theme.storageUtil.get('products-layout');
        if (layout && layout === 'list') {
          const toggle = document.getElementById(`${layout}-layout-opt`);
          if (toggle) toggle.click();
          this.handleLayoutChange(null, layout);
        }
      }

      if (this.compareToggle) {
        this.compareToggle.addEventListener('change', this.toggleCompare.bind(this));

        const isChecked = theme.storageUtil.get('compare-toggle', true);
        if (isChecked !== null) {
          this.toggleCompare(null, isChecked, true);
        } else {
          this.toggleCompare(null, this.compareToggle.checked, false);
        }

        setTimeout(() => {
          this.classList.add('transition-ready');
          this.productsGrid.classList.add('transition-ready');
        }, 500);
      } else if (theme.settings.compareToggle === 'none') {
        this.toggleCompare(null, true, false);
      }

      if (!this.filtersComponent && this.sortBy) {
        this.sortBy.addEventListener('change', ProductsToolbar.handleSortByChange);
      }
    }

    /**
     * Updates the UI to reflect the compare state
     * @param {object} evt - Change event object
     * @param {boolean} checked - Whether compare is enabled or not (optional)
     * @param {boolean} persist - Whether to persist the new state (optional)
     */
    toggleCompare(evt, checked = null, persist = true) {
      const isChecked = evt ? evt.target.checked : checked;
      this.productsGrid.dataset.compare = isChecked;

      const compareButton = document.getElementById('compare-drawer-open');
      compareButton.classList.toggle('is-out', !isChecked);

      if (!evt && this.compareToggle) this.compareToggle.checked = isChecked;

      if (persist && !Shopify.designMode) {
        theme.storageUtil.set('compare-toggle', isChecked);
      }

      // Load scripts/styles if not already loaded
      if (isChecked) {
        const resourcesTag = document.getElementById('compare-resources');
        if (resourcesTag) {
          const resources = JSON.parse(resourcesTag.textContent);
          resources.forEach((resource) => {
            if (resource.type === 'js') {
              const script = document.createElement('script');
              script.src = resource.path;
              document.head.appendChild(script);
            } else if (resource.type === 'css') {
              const link = document.createElement('link');
              link.href = resource.path;
              link.type = 'text/css';
              link.rel = 'stylesheet';
              document.head.appendChild(link);
            }
          });
          resourcesTag.remove();
        }
      }
    }

    /**
     * Toggles open/closed state of the filters on desktop.
     */
    toggleFilters() {
      this.filterToggle.classList.toggle('is-active');
      this.filtersOpen = this.filterToggle.classList.contains('is-active');
      this.filterToggle.setAttribute('aria-expanded', this.filtersOpen);

      if (theme.mediaMatches.lg) {
        this.filtersColumn.classList.toggle('lg:js-hidden', !this.filtersOpen);
        const productsList = document.querySelector('.main-products-grid__results > .grid');

        productsList.className = this.filtersOpen
          ? productsList.dataset.filtersOpenClasses
          : productsList.dataset.filtersClosedClasses;
        // Focus the filters column when opened (minimal).
        if (this.filtersOpen) {
          setTimeout(() => {
            const target = document.querySelector('div.main-products-grid__filters');
            if (target) target.focus({ preventScroll: true });
          }, 100);
        }
      } else {
        this.filtersComponent.open();
      }
    }

    /**
     * Handles 'change' events on the layout switcher buttons.
     * @param {object} evt - Event object.
     * @param {string} layout - 'grid' or 'list' - the layout to change to.
     */
    handleLayoutChange(evt, layout) {
      this.productsGrid.dataset.layout = layout || evt.target.value;
      if (!layout) theme.storageUtil.set('products-layout', evt.target.value);
    }

    /**
     * Handles when a sort by dropdown is changed (and filtering is disabled)
     * @param {object} evt - Event object.
     */
    static handleSortByChange(evt) {
      const urlObj = new URL(window.location.href);
      urlObj.searchParams.set('sort_by', evt.detail.selectedValue);
      urlObj.hash = 'products-toolbar';
      window.location.href = urlObj.toString();
    }
  }

  customElements.define('products-toolbar', ProductsToolbar);
}

/**
 * Search functionality for the product grid
 */

document.addEventListener('DOMContentLoaded', function() {
  function filterProductGrid(productList, searchValue) {
    const itemNodes = productList.querySelectorAll('li.js-pagination-result');
    const noResultsNode = document.getElementById('ProductsGridNoResults');
    const q = (searchValue || '').trim().toLowerCase();
    const isSearching = q.length > 0;
    let anyVisible = false;

    itemNodes.forEach((item) => {
      const isPromo = item.className.indexOf('promo-item--') !== -1;
      if (isPromo) {
        // Hide promos only while searching, show when cleared
        item.style.display = isSearching ? 'none' : '';
        return;
      }

      const title = item.querySelector('p.card__title')?.innerText || '';
      const match = !isSearching || title.toLowerCase().includes(q);
      item.classList.toggle('hidden', !match);
      if (match) anyVisible = true;
    });

    let resultsCount = productList.querySelectorAll('li.js-pagination-result:not(.hidden)').length;

    if (q)
      setTimeout(() => {
        document.getElementById('search-status').textContent = `Results updated. ${resultsCount} results for “${searchValue}”.`;
      }, 1000);
    else
      document.getElementById('search-status').textContent = '';

    if (noResultsNode) {
      if (isSearching && !anyVisible) {
        noResultsNode.textContent = `Sorry, nothing found for "${searchValue}".`;
        noResultsNode.removeAttribute('hidden');
      } else {
        noResultsNode.setAttribute('hidden', '');
      }
    }
  }

  const makeDebounce = (fn, delay = 250) => {
    if (typeof window.debounce === 'function') return window.debounce(fn, delay);
    let t = null;
    return function(...args) {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), delay);
    };
  };
  const dFilterProductGrid = makeDebounce(filterProductGrid, 250);

  // Find the closest products-toolbar and its associated product grid
  const searchWrapper = document.querySelector('.search-wrapper');
  if (!searchWrapper) return; // No search functionality needed
  
  const toolbar = searchWrapper.closest('products-toolbar');
  if (!toolbar) return; // Search must be within a products-toolbar
  
  const sectionRoot = toolbar.closest('.section') || document;
  const productList = sectionRoot.querySelector('.main-products-grid');
  if (!productList) return; // No product grid found
  
  const form = searchWrapper.querySelector('form.search');
  const input = form?.querySelector('input[type="search"]');
  if (!form || !input) return;

  const handleInputChange = () => {
    dFilterProductGrid(productList, input.value);
  };

  input.addEventListener('input', handleInputChange);
  // Prevent Enter from submitting the form (keep filtering in-place)
  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  });
  form.addEventListener('submit', (e) => {
    e.preventDefault();
    handleInputChange();
  });
});